import { SVGProps } from 'react'

const LayersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 15 14"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="m14.64 9.865-2.76-1.398 2.613-1.352c.083-.043.083-.112 0-.154l-2.948-1.493 3.099-1.602a.417.417 0 0 0 .239-.37.416.416 0 0 0-.242-.368L8.596.068A.69.69 0 0 0 8.29 0a.68.68 0 0 0-.285.059l-6.87 3.216a.41.41 0 0 0-.252.366.41.41 0 0 0 .246.372l3.3 1.622-3.155 1.477c-.084.04-.084.105 0 .146l2.8 1.378-2.939 1.376a.41.41 0 0 0-.252.366.41.41 0 0 0 .246.37l6.481 3.188a.668.668 0 0 0 .292.064.68.68 0 0 0 .306-.07l6.436-3.328a.417.417 0 0 0 .24-.37.416.416 0 0 0-.244-.368ZM8.272.657A.093.093 0 0 1 8.29.656c.01 0 .017 0 .013-.001L13.925 3.5 7.918 6.607l-.016.001-.003.004-6.02-2.96L8.271.656ZM7.92 13.343a.08.08 0 0 1-.018.001l-.002.004-6.02-2.96 2.847-1.334 2.884 1.419a.67.67 0 0 0 .291.063.676.676 0 0 0 .307-.07l3.053-1.578 2.663 1.349-6.005 3.106Z"
    />
  </svg>
)
export default LayersIcon
